export enum LoanCalculatorActions {
  Seq = 'seq',
  Lookups = 'lookups',
  Auto = 'auto',
  Clear = 'clear',
  Add = 'add',
  Delete = 'delete',
  PrintLoanDemoSchedule = 'printloandemoschedule',
}

export interface LoanCalculatorFailure {
  message: string
}

export enum LoanCalculatorServiceErrorCode {
  GENERAL,
}

export interface LoanCalculatorSequenceServerData {
  DemoScheduleSequenceID: number
  HashSum_DemoScheduleSequenceID_: string
}

interface LoanCalculatorLookup {
  ID: number
  Title: string
  Title_ALT: string
}

export type LoanCalculatorLookupsServerData = LoanCalculatorLookup[]

export interface AutoLoanAttributes {
  Schedule: number
  StartDate: string
  EndDate: string
  Amount: number
  FirstInstDate: string
  InterestRate: number
  InterestType: any
  Upfront: any
  GracePeriodPri: any
  GracePeriodInt: number
  FrequencyValue: any
  Frequency: number
  SkipDirection: any
  Rounding: any
  AnnualBasis: number
  ConsiderHolidays: number
  GracePeriod_InterestAccrual: any
  ProcedureFeeType: any
  ProcedureFeeRate: number
  ProcedureFeeInstType: number
  ProcedureFeeInstPeriods: number
  OtherExpenses_Pre: number
  OtherExpenses_Post: number
  InsRate: number
  InsRateTypeID: number
  WeekDays: any
  MonthDays: any
  SpotPayment: any
  DemoScheduleSequenceID: number
  HashSum_DemoScheduleSequenceID_: string
}
